import { VerticalStack } from '@/components/utils/linearLayouts';
import { Link, Typography } from '@mui/material';
import { ComponentProps, ReactNode } from 'react';
import { Link as RouterLink } from 'react-router';

const BAND_NAME_SX = {
    textDecoration: 'none',
    color: '#FFF',
    fontSize: '22px',
    lineHeight: '28px',
};

// The band's identity lines, which give it its height. The placeholder renders them empty rather
// than restating what they measure.
export const LeftRailBandIdentity = ({
    patientId,
    name,
    details,
}: {
    patientId?: string;
    name?: string;
    details?: ReactNode;
}) => (
    <VerticalStack>
        {patientId ? (
            <Link component={RouterLink} to={`/patients/${patientId}`} sx={BAND_NAME_SX}>
                {name}
            </Link>
        ) : (
            // Nothing to link to yet, and a link here would be a tab stop announcing no name.
            <Typography sx={BAND_NAME_SX}>{' '}</Typography>
        )}
        <Typography fontSize='14px' lineHeight='20px' fontWeight='500'>
            {details ?? ' '}
        </Typography>
    </VerticalStack>
);

// The rail's header band: the layout the band and its placeholder share.
export const LeftRailHeaderBand = ({
    children,
}: {
    children?: ComponentProps<typeof VerticalStack>['children'];
}) => (
    <VerticalStack
        position='sticky'
        top={0}
        bgcolor='#2E5D5B'
        p={3}
        color='#f3f3f3'
        gap={1}
        zIndex={1}
    >
        {children}
    </VerticalStack>
);
